import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
// Routes 

// Components 


import LinearProgress from '@mui/material/LinearProgress';

// Icons 

import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

// import Dropdown from './Dropdown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getDoctorGroupAccessList, getGroup } from '../../../../routes/hacker/users';
import GroupAccessRow from './GroupAccessRow';
import { setIsGroupInfoPopupOpened, setSelectedGroup } from '../../../../redux/features/hacker/users/groupsAccess';
import { setIsDoctorInfoPopupOpened, setSelectedDoctor } from '../../../../redux/features/hacker/users/doctorsAccess';

const GroupAccessList: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);  
    const selectedDoctor = useAppSelector(state => state.doctorsAccess.selectedDoctor);  

    const [postionX, setPositionX] = useState(0); 
    const [positionY, setPositionY] = useState(0); 

    const [groupAccessList, setGroupAccessList] = useState([]); 

    // -- 

    const getGroupAccessList = async () => { 

      const res = await getDoctorGroupAccessList(selectedDoctor?._id) as any; 

      if (res.data.status === 200) { 

        setGroupAccessList(res.data.groupAccessList);  

      };

    }; 

    // -- 

    const handleSelection = async (e: any, groupAccess: any) => { 

        const res = await getGroup(groupAccess.groupId); 

        if (res?.data.status === 200) { 

            dispatch(setSelectedGroup(res.data.group));
            dispatch(setIsGroupInfoPopupOpened(true)); 

            dispatch(setSelectedDoctor(null)); 
            dispatch(setIsDoctorInfoPopupOpened(false)); 
            
        }; 

      setPositionX(e.pageX);
      setPositionY(e.pageY); 

    }; 

    // -- 

    useEffect(() => { 

        if (selectedDoctor) { 

            getGroupAccessList(); 

        }; 

    },[selectedDoctor]); 

    // -- 
    
    return (

        <Box>

            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxHeight: '100%',
              minWidth: '35vw', 
              color: colors?.text, 
            }}>          

            <Box
                sx={{ 
                    display: 'flex',
                    flex: 'row',
                    alignItems: 'center',
                    width: '100%', 
                    color: colors?.text, 
                    marginBottom: 1,
                    fontWeight: 'bold'
                }}
            >Doctor's Access List
                
            </Box>  

            { groupAccessList?.length >= 1 && 
            <Box sx={{ 
                overflow: 'auto',
                minWidth: '100%',
                height: 350,
                marginTop: '2vh',
                borderRadius: 3,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
            }}>
        
                <List dense>
        
                {groupAccessList?.map((groupAccess, index) => (
        
                    <ListItem sx={{ color: colors?.text }} onClick={(e) => handleSelection(e, groupAccess)} button key={index}>

                        <GroupAccessRow 
                            item={groupAccess}
                        /> 
       
                    </ListItem>
                ))}
        
                </List>
        
            </Box>}

            {groupAccessList?.length === 0 &&         
          
                <Box sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-evenly', 
                height: '100%',
                width: '80%', 
            }}>

                <Box
                    sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>

                    <LinearProgress sx={{ width: 500, marginBottom: 10 }} /> 

                    <Box>Retrieving Group Access List...</Box>

                </Box>

            </Box>}

          {/* { selectedGroup && <Dropdown positionX={postionX} positionY={positionY - 30} />} */}
        
            </Box>

        </Box>
    
      );

};

export default GroupAccessList;